<template>
  <div class="drag-zone">
    <slot></slot>
  </div>
</template>

<script>
/**
 * 2.0.0
 * NPM에 등록된 1.2.2 버전 index.js bug로 2.0.0 소스를 임시로 추가하여 사용
 * https://github.com/surmon-china/vue-drag-zone/
 */
export default {
  name: 'drag-zone',
  props: {
    options: {
      type: Object,
      default() {
        return {
          direction: 'horizontal',
        };
      },
    },
  },
  computed: {
    horizontal() {
      return this.options.direction === 'horizontal';
    },
  },
};
</script>

<style scoped>
.drag-zone {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/external/VueDragZone/zone.vue